<div class="container-fluid p-0">
  <div class="row">
    <div class="col-12">
      @if (geschaeft) {
        <div class="mt-2 detail-form">
          <ng-template [ngTemplateOutlet]="title"></ng-template>
          <ng-template [ngTemplateOutlet]="detailsTabset"></ng-template>
          <ng-template [ngTemplateOutlet]="beteiligteGrundstuecke"></ng-template>
        </div>
      } @else {
        <cap-spinner-small></cap-spinner-small>
      }
    </div>
  </div>
</div>

<ng-template #title>
  <cap-content-header>
    <cap-title>
      <span
      >{{ "Grundbuchgeschaeft" | translate }}:
        <span>{{ geschaeft | kompaktGrundbuchgeschaeft }}{{ geschaeft.beschreibung ? ", " + geschaeft.beschreibung : "" }}</span>
      </span>
    </cap-title>
    <cap-title-functionbar>
      <div class="inline-form float-end">
        <div ngbDropdown placement="bottom-right">
          <button
            [disabled]="!hasRightGbMeldung || geschaeft.meldungsrelevant === 'NEIN'"
            class="btn btn-sm btn-white buttonGroup"
            ngbDropdownToggle
            type="button">
            <span aria-hidden="true" class="fas fa-ellipsis-v fa-fw"></span>
          </button>
          <div class="dropdown-menu" ngbDropdownMenu style="margin-right: 10px">
            <cap-link [params]="[geschaeft.id.id]" [target]="navTargets.NAV_GRUNDBUCHMELDUNG" class="dropdown-item">
              {{ "navigation.grundbuchmeldung" | translate }}
            </cap-link>
            @if (isECH0134On && geschaeft.eCH0134GeneriertAm) {
              <cap-ech0134-grundbuchmeldung-delete-button
                [geschaeft]="geschaeft"></cap-ech0134-grundbuchmeldung-delete-button>
            }
          </div>
        </div>
      </div>
    </cap-title-functionbar>
  </cap-content-header>
</ng-template>

<ng-template #detailsTabset>
  <ul [(activeId)]="activeTabId" #nav="ngbNav" class="nav-tabs" ngbNav>
    <li [ngbNavItem]="DEFAULT_TAB_ID">
      <a ngbNavLink>{{ "Geschaeftdetails" | translate }}</a>
      <ng-template id="tabGeschaeftDetail" ngbNavContent>
        <div id="details">
          <div class="row mt-md-2">
            <div class="col-md-6 col-sm-12">
              <cap-kopfdatenelement
                [value]="geschaeft.gbAmt && geschaeft.gbAmt?.name | translateName"
                label="Grundbuchamt"></cap-kopfdatenelement>
              <cap-kopfdatenelement label="Tagebuchnummer">
                {{ geschaeft | kompaktGrundbuchgeschaeft }}
                @if (appformatConfigService.settingsConfig$ | async; as settingsConfig) {
                  @if (settingsConfig.isCmisConfigured) {
                    <cap-cmis
                      [target]="{ itemType: 'Geschaeft', id: geschaeft.timePoint?.id.id, tooltipParam: geschaeft.timePoint | formatTimepoint }"></cap-cmis>
                  } @else if (settingsConfig.isDokuLinkGeschaeftConfigured) {
                    <cap-dokulink
                      [item]="dokuLinkBuilderFactory.create('GBGESCHAEFT').setEntry(geschaeft).build()"></cap-dokulink>
                  }
                }
              </cap-kopfdatenelement>
              <cap-kopfdatenelement [value]="geschaeft.status | translate"
                                    label="Tagebuchstatus"></cap-kopfdatenelement>
              <cap-kopfdatenelement [value]="geschaeft.eingangTagebuch | datumZeit"
                                    label="Eingang"></cap-kopfdatenelement>
              <cap-kopfdatenelement [value]="geschaeft.ausgangTagebuch | datum" label="Ausgang"></cap-kopfdatenelement>
            </div>
            <div class="col-md-6 col-sm-12">
              <cap-kopfdatenelement [value]="geschaeft.anmelderText" label="AnmelderText"></cap-kopfdatenelement>
              <cap-kopfdatenelement [value]="eGVAnmeldung" label="EGVAnmeldung"></cap-kopfdatenelement>
              @if (isAuftragsmodulOn && !(auftrag?.mAuftragNummer?.access === "NONE")) {
                <cap-kopfdatenelement label="AuftragsNummerAblage">
                  <div class="row">
                    <div class="col-md-6 col-sm-6">
                      {{ auftrag && auftrag | auftragsNummer }}
                    </div>
                    <div class="col-md-6 col-sm-6">
                      {{ auftrag && auftrag.ablageNummer }}
                    </div>
                  </div>
                </cap-kopfdatenelement>
              }
              <cap-kopfdatenelement [value]="geschaeft.egbtbid" label="EGBTBID"></cap-kopfdatenelement>
              @if (geschaeft?.mRegistraturText?.access === "ALLOWED") {
                <cap-kopfdatenelement [value]="geschaeft.registraturText"
                                      label="RegistraturText"></cap-kopfdatenelement>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <cap-kopfdatenelement [bodyClass]="'col-md-12 col-sm-12'" [labelClass]="'col-md-12 col-sm-12'"
                                    label="Beschreibung">
                <div class="row col-md-12" style="padding-left: 8px">
                  @if (geschaeft.mBeschreibung.access === "NONE") {
                    <div class="mb-2">
                      <span>{{ "gemaessGrundbuch" | translate }}</span>
                    </div>
                  } @else {
                    {{ geschaeft.beschreibung }}
                  }
                  <ng-template #beschreibung>
                    {{ geschaeft.beschreibung }}
                  </ng-template>
                </div>
              </cap-kopfdatenelement>
            </div>
          </div>
          <cap-stammperson-table [stammpersonen]="geschaeft.anmelder" [tableFullWidth]="false" [title]="'Anmelder'">
          </cap-stammperson-table>

          <ng-template
            [ngTemplateOutlet]="isShowAvReferenzNummern ? avRequestNummer : geometerGeschaefte"></ng-template>
        </div>
      </ng-template>
    </li>
    @if (isECH0134On) {
      <li [disabled]="!hasECH0134Right" [ngbNavItem]="ECH_0134_TAB_ID">
        <a ngbNavLink>{{ "Meldungsempfaenger" | translate }}</a>
        <ng-template id="tabMeldungsempfaenger" ngbNavContent>
          <cap-ech0134-grundbuchgeschaeft-detail [geschaeft]="geschaeft"></cap-ech0134-grundbuchgeschaeft-detail>
        </ng-template>
      </li>
    }
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</ng-template>

<ng-template #geometerGeschaefte>
  <cap-beschreibung-table-wrapper [tableFullWidth]="false">
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      <h3>{{ "Geometergeschaefte" | translate }}</h3>
    </span>
    <ng-container class="cap-table-wrapper-content">
      <cap-geogeschaeft-table [listLoader]="geoGeschaeftLoader" [showTotal]="false"
                              [showZeilenSelect]="false"></cap-geogeschaeft-table>
    </ng-container>
  </cap-beschreibung-table-wrapper>
</ng-template>

<ng-template #avRequestNummer>
  <div name="title">
    <h3>{{ "Geometergeschaefte" | translate }}</h3>
  </div>
  <div class="mb-2 mt-2">
    @if (avReferenzNrs$ | formatAvReferenznummern | async; as value) {
      <span>{{ value }}</span>
    } @else {
      <cap-spinner-small></cap-spinner-small>
    }
  </div>
</ng-template>

<ng-template #beteiligteGrundstuecke>
  <cap-content-header>
    <cap-title name="title">
      <h3>{{ "BeteiligteGrundstuecke" | translate }}</h3>
    </cap-title>
    <cap-title-functionbar>
      @if (grundstueckIds.length >= 2) {
        <button
          (click)="getZip()"
          [disabled]="gbPrintService.zipInProgressMap.get(0)"
          class="btn btn-outline-primary btn-sm me-2"
          type="button">
          @if (gbPrintService.zipInProgressMap.get(0)) {
            <span class="spinner-border spinner-border-sm text-primary me-1"></span>
          }
          {{ "Auszüge" | translate }} {{ "(" + grundstueckIds.length + ")" }}
        </button>
      }
      <cap-functionbar-searchresult-buttons [listLoader]="grundstueckLoader"></cap-functionbar-searchresult-buttons>
    </cap-title-functionbar>
  </cap-content-header>
  <cap-grundstueck-table
    (grundstueckIdsListEventItem)="updateCheckedGrundstueckIdList($event)"
    [listLoader]="grundstueckLoader"
    [showZeilenSelect]="false">
  </cap-grundstueck-table>
</ng-template>
